import React from "react";

// The restrained, non-blocking discovery moment: shown ONCE after a
// successful SAVE YOUR TASTE, on top of (never instead of) the Profile the
// user just earned. Not a modal takeover, no confetti/badges — a dismissible
// inline card the user can act on immediately or ignore entirely.
export default function EditionsUnlockedBanner({ onExplore, onDismiss }) {
  return (
    <div
      data-testid="editions-unlocked-banner"
      className="relative mx-auto max-w-[440px] mt-4 rounded-2xl bg-[#0c0d12] border border-white/12 px-5 py-4 flex items-center gap-4"
    >
      <div className="flex-1 min-w-0">
        <p className="font-display font-black uppercase tracking-[-0.01em] text-bone text-[13px]">
          Taste Editions unlocked
        </p>
        <p className="mt-0.5 font-body text-[12px] text-silver">
          Go deeper. Sharpen your taste.
        </p>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <button
          type="button"
          data-testid="editions-unlocked-dismiss"
          onClick={onDismiss}
          aria-label="Dismiss"
          className="font-body text-white/40 hover:text-white/70 text-lg leading-none px-1"
        >
          ×
        </button>
        <button
          type="button"
          data-testid="editions-unlocked-explore"
          onClick={onExplore}
          className="font-body font-bold text-[11px] tracking-[0.14em] uppercase text-[#05070a] rounded-full px-4 py-2 whitespace-nowrap"
          style={{ background: "linear-gradient(90deg,var(--tt-left),var(--tt-right))" }}
        >
          Explore →
        </button>
      </div>
    </div>
  );
}
